import React from 'react';
import ItemList from '../components/ItemList';

function Hamburguesas() {

  const menusList4 = [
    { name: 'Hamburguesa Normal', description: 'Pollo o ternera, lechuga, tomate y salsa yogur', price: '5,00€', img: "https://www.pcs.es/wp-content/uploads/2021/10/30020_hamburguesa_crunchy_media-scaled.jpg" },
    { name: 'Hamburguesa Especial', description: 'Pollo o ternera, carne kebab, huevo, queso, lechuga, tomate y salsa yogur', price: '8,00€', img: "https://www.elindependiente.com/wp-content/uploads/2017/12/kebab-hamburguesa-723x406.jpg" },
  ];



  return (
    <div id="hamburguesas" className="container mx-auto mt-8 px-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Hamburguesas</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {menusList4.map((menu) => (
          <ItemList
            key={menu.key}
            name={menu.name}
            description={menu.description}
            price={menu.price}
            img={menu.img}
            menuPrice={menu.menuPrice}
            menuIncludes={menu.menuIncludes}
          />
        ))}
      </div>
    </div>
  );
}

export default Hamburguesas;
